/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputNews
 */
export interface InputNews {
    /**
     * 
     * @type {Array<string>}
     * @memberof InputNews
     */
    roles: Array<InputNewsRolesEnum>;
    /**
     * 
     * @type {string}
     * @memberof InputNews
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof InputNews
     */
    title: string;
}


/**
 * @export
 */
export const InputNewsRolesEnum = {
    Admin: 'admin',
    IstarZone: 'istar_zone',
    IstarDivision: 'istar_division',
    OtgCoordinator: 'otg_coordinator',
    Team: 'team',
    Viewer: 'viewer',
    OsgCoordinator: 'osg_coordinator',
    EwOperator: 'ew_operator'
} as const;
export type InputNewsRolesEnum = typeof InputNewsRolesEnum[keyof typeof InputNewsRolesEnum];


/**
 * Check if a given object implements the InputNews interface.
 */
export function instanceOfInputNews(value: object): boolean {
    if (!('roles' in value)) return false;
    if (!('text' in value)) return false;
    if (!('title' in value)) return false;
    return true;
}

export function InputNewsFromJSON(json: any): InputNews {
    return InputNewsFromJSONTyped(json, false);
}

export function InputNewsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputNews {
    if (json == null) {
        return json;
    }
    return {
        
        'roles': json['roles'],
        'text': json['text'],
        'title': json['title'],
    };
}

export function InputNewsToJSON(value?: InputNews | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'roles': value['roles'],
        'text': value['text'],
        'title': value['title'],
    };
}

